import React, { useRef } from 'react';
import { esconderNome, formatarTempo } from '../../helpers/FormatHelpers';
import { buscarCorSLA } from '../../rules/regraSLA';
import { isFilaInfantil } from '../../rules/regraFilaPS';

const CardCadastroDetalhe = ({ dataPacientes, tipoSelecionado, ps_tipo }) => {
  const isInfantil = ps_tipo === 'infantil';
  const isPediatria = (item) => isFilaInfantil(tipoSelecionado, item);

  const pacientesAdulto = dataPacientes.filter((item) => !isPediatria(item));
  const pacientesInfantil = dataPacientes.filter((item) => isPediatria(item));

  const title = isInfantil ? 'PS Infantil' : 'PS Adulto';
  const pacientes = isInfantil ? pacientesInfantil : pacientesAdulto;
  const total = pacientes.length;

  return (
    <>
      <div className='card-pacientes'>
        <div className='card-grupo'>
          <div className='card-title'>{title}</div>
          <div className='card-title'>{total}</div>
        </div>
        <div className='card-header'>
          <table>
            <thead>
              <tr>
                <th>Class. de Risco</th>
								<th>Situação</th>
                <th>Paciente</th>
                <th>Totem</th>
								<th>Senha</th>
                <th style={{ textAlign: 'right' }}>Espera</th>
                <th style={{ textAlign: 'right' }}>Espera Total</th>
              </tr>
            </thead>
            <tbody>
              {pacientes.map((paciente, index) => {
                const totem = paciente.DESCRICAOITEM.split(' - ')[0] ?? '';
                const espera = paciente.VALOR ?? 0;
                const esperaTotal = paciente.VALORTRIAGEM ?? espera;
                const corSLA = buscarCorSLA({ tipoCard: tipoSelecionado, tempo: espera, situacaoAtendimento: paciente.SITUACAO, tipoPaciente: ps_tipo });
								const senha = paciente.DESCRICAOITEM.split(' - ')[2] ?? paciente.DESCRICAOITEM.split(' - ')[1] ?? '';

                let situacao = paciente.SITUACAO;
								if (paciente.SITUACAO === 'Aguardando Atendimento') {
									situacao = 'Aguard. Atendimento';
								}

                return (
                  <tr key={index}>
                    <td><div className={'alert-label ' + paciente.NOMECOR}></div></td>
										<td>{situacao}</td>
                    <td>{esconderNome(paciente.NOMEPACIENTE)}</td>
                    <td>{totem}</td>
										<td>{senha}</td>
                    <td className='col-espera' style={{ textAlign: 'right' }}>
                      <span className={"sla-dot " + corSLA}></span>
                      <span style={{ marginLeft: '10px' }}>{formatarTempo(espera)}</span>
                    </td>
                    <td className='col-espera' style={{ textAlign: 'right' }}>{formatarTempo(esperaTotal)}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default CardCadastroDetalhe;